import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Published blog post summaries, optionally filtered by category. */
export default function useBlogPosts(category) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios
      .get(`${API}/blog/posts`, { params: category ? { category } : {} })
      .then((r) => alive && setPosts(r.data))
      .catch(() => alive && setError(true))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [category]);

  return { posts, loading, error };
}
